import axios, { AxiosError } from 'axios'

export const CHECK_STATUS = {
  CONTINUE: 'Continue',
  RESPONDED: 'Responded',
} as const
type CheckStatusType = typeof CHECK_STATUS[keyof typeof CHECK_STATUS]

export type CheckResponse = {
  code: number
  status: CheckStatusType
  waitTime: number
  elapsedTime: number
  unlockCode: string
  message: string
}

export const checkresponse = async (sessionId: string): Promise<CheckResponse> => {
  try {
    const url = `${process.env.REACT_APP_API_SERVER}/v1/checkresponse`
    const response = await axios.get(url, { headers: { authorization: `Bearer ${sessionId}` } })

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error as AxiosError)
  }
}
